<script setup lang="ts">
import './assets/style.scss'
import type { PropType } from 'vue'
import type { MapGroupsShortType } from './../model/types.ts'

defineProps({
  groups: {
    type: Array as PropType<MapGroupsShortType[]>,
    default: () => [],
  },
})

const emits = defineEmits(['select-parent'])

/**
 * Функция обработки клика
 * @param id
 */
const clickHandler = (id: number) => {
  emits('select-parent', id)
}
</script>

<template>
  <p>{{ $t('itf.parent_map_groups') }}:</p>

  <p class="mt-1" v-for="group in groups">
    <RouterLink to="#" @click.prevent="clickHandler(group.id)">{{ group.name }}</RouterLink>
  </p>
</template>
